export const PageIds = {
    HOME: 'home',
    REPORTS: 'reports',
    SETTINGS_ACCOUNT_SUBSCRIPTION: 'settings_billing_subscription',
    SETTINGS_ACCOUNT_PRIVACY: 'settings_billing_privacy',
    SETTINGS_ASSET_GENERAL_SETTINGS: 'settings_asset_general_settings',
    SETTINGS_ASSET_MAPPING: 'settings_asset_mapping',
    SETTINGS_ASSET_PLUGIN: 'settings_asset_plugin',
} as const;
